/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { LocalStorageService } from '../../../services'
import { DigitalVaultDocumentAction } from '../index'
import { useParams } from 'react-router-dom'
import { SimpleLoading } from '../../pures'

/**
 * @author Nestor Sandoval
 * @description Redirección desde alertas por correo hacia documentos específicos (bitácora)
 * @date 20-10-2025
 */
const RequestDocumentRedirectAction = () => {
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [hasSession, setHasSession] = useState(false)
  const localStorageService = new LocalStorageService()
  const hasValidatedRef = React.useRef(false)

  // Verifica si hay sesión activa; si no, redirige al login
  const validateSession = async () => {
    if (hasValidatedRef.current) {
      return
    }
    hasValidatedRef.current = true
    const token = await localStorageService.getLocalStorageItem('token')
    const user = await localStorageService.getLocalStorageItem('user')

    if (!token || !user) {
      console.log('No active session - saving redirect URL and going to login')
      await localStorageService.setLocalStorageItem('pendingRedirectUrl', `/request-document/${id}`)
      window.location.href = '/#/'
    } else {
      console.log('Active session found - rendering full')
      setHasSession(true)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    validateSession()
  }, [id])

  if (isLoading) return <SimpleLoading />

  return (
    <div className='standard-wrapper' style={{ padding: '15px' }}>
      <DigitalVaultDocumentAction documentId={id} />
    </div>
  )
}

export default RequestDocumentRedirectAction
